import React from "react";
import { useFieldArray } from "react-hook-form";

import { CLabel } from "@coreui/react";

import { PreviewGrid } from "./PreviewGrid";
import { UploadZone } from "./UploadZone";

export const CComplexUpload = ({
  onlyView = false,
  control,
  name,
  className = "",
  label,
  required,
}) => {
  //#region Data
  const { fields, append, remove } = useFieldArray({
    control,
    name,
    keyName: "__id",
  });
  //#endregion

  //#region Render
  return (
    <div className={`w-full form-group ${className}`}>
      {label && (
        <CLabel>
          {label} {required && <span className="text-danger">*</span>}
        </CLabel>
      )}

      {!onlyView && <UploadZone append={append} />}

      <PreviewGrid images={fields} remove={remove} onlyView={onlyView} />
    </div>
  );
  //#endregion
};
